import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { PaymentSuccessPageContent } from 'client/contents/PaymentSuccessPageContent/PaymentSuccessPageContent'

type TProps = {}

const PaymentSuccessPage: FC<TProps> = ({}) => {
  return (
    <article className="bg-palette-black flex h-full w-full flex-col">
      <AppHead />
      <PaymentSuccessPageContent />
    </article>
  )
}

// @ts-expect-error
PaymentSuccessPage.layout = (page) => page

export default PaymentSuccessPage
